export class TrueFalseQuestion {
  constructor(
    public QuestionId: string,
    public Title: string,
    public QuestionText: string,
    public Selected: boolean
  ) {}
}
